import { ReactNode } from 'react';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Text, TextLink, useModalControl } from '@frontend/design-system';
import { PrivacyRulesTray } from '../privacy-rules-tray';
import { TrayMode } from '../types';

type FormModeTrayHeaderProps = {
  trackingIdPrefix: string;
};

const FormModeTrayHeader = ({ trackingIdPrefix }: FormModeTrayHeaderProps) => {
  const { t } = useTranslation('bulk-messaging');
  const { modalProps, triggerProps } = useModalControl();

  return (
    <>
      <Text color='subdued'>
        <Trans t={t}>
          Select the filters that describe the contacts you are targeting.
          <TextLink
            {...triggerProps}
            css={{ marginLeft: theme.spacing(0.75) }}
            trackingId={`${trackingIdPrefix}-privacy-rules-btn`}
          >
            Privacy Rules
          </TextLink>
        </Trans>
      </Text>
      <PrivacyRulesTray {...modalProps} trackingIdPrefix={trackingIdPrefix} />
    </>
  );
};

type TrayHeaderProps = FormModeTrayHeaderProps & {
  mode?: TrayMode;
  setMode: (mode: TrayMode) => void;
  title?: ReactNode;
  trackingIdPrefix: string;
};

export const TrayHeader = ({ mode, setMode, title, trackingIdPrefix }: TrayHeaderProps) => {
  const { t } = useTranslation('bulk-messaging');
  const hasBack = mode !== 'display';

  return (
    <div>
      <div css={{ display: 'flex', columnGap: theme.spacing(1), alignItems: 'center' }}>
        {hasBack && (
          <Button
            variant='tertiary'
            iconName='caret-left'
            onClick={() => setMode('display')}
            css={{
              svg: {
                color: theme.colors.neutral90,
                height: 20,
                width: 20,
              },
            }}
          />
        )}
        <Heading level={2} css={{ margin: 0 }}>
          {title ?? t('Create Audience')}
        </Heading>
      </div>
      {mode === 'form' && <FormModeTrayHeader trackingIdPrefix={trackingIdPrefix} />}
    </div>
  );
};
